const { same } = require('../utils');

exports.computeIsBackgroundFromCanvasStateIems = canvasStateItems => same(canvasStateItems, 'isBackground');
